import { render } from "./BecomeSeller.vue?vue&type=template&id=9af78494&scoped=true"
import script from "./BecomeSeller.vue?vue&type=script&lang=js"
export * from "./BecomeSeller.vue?vue&type=script&lang=js"

import "./BecomeSeller.vue?vue&type=style&index=0&id=9af78494&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af78494"]])

export default __exports__